var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUxaudit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    stroke: "black"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_2908_11628)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.3623 18.6667V16H28.029V18.6667H17.3623ZM13.3623 37.3333C13.0087 37.3333 12.6695 37.1928 12.4195 36.9428C12.1694 36.6928 12.029 36.3536 12.029 36V12C12.029 11.6464 12.1694 11.3072 12.4195 11.0572C12.6695 10.8071 13.0087 10.6667 13.3623 10.6667H33.3623V23.3333C34.3524 23.75 35.2566 24.3468 36.029 25.0933V8H13.3623C12.3014 8 11.284 8.42143 10.5339 9.17157C9.78373 9.92172 9.3623 10.9391 9.3623 12V36C9.3623 37.0609 9.78373 38.0783 10.5339 38.8284C11.284 39.5786 12.3014 40 13.3623 40H30.029C28.8629 39.9999 27.7089 39.7635 26.6367 39.3052C25.5645 38.8469 24.5962 38.1761 23.7903 37.3333H13.3623ZM36.753 39.9427L33.2103 36.4C32.2599 37.0066 31.1565 37.3303 30.029 37.3333C28.8423 37.3333 27.6822 36.9814 26.6956 36.3221C25.7089 35.6629 24.9398 34.7258 24.4857 33.6294C24.0316 32.5331 23.9128 31.3267 24.1443 30.1628C24.3758 28.9989 24.9472 27.9298 25.7863 27.0907C26.6254 26.2516 27.6945 25.6801 28.8584 25.4486C30.0223 25.2171 31.2287 25.3359 32.3251 25.79C33.4214 26.2442 34.3585 27.0132 35.0178 27.9999C35.6771 28.9866 36.029 30.1466 36.029 31.3333C36.026 32.4608 35.7023 33.5642 35.0956 34.5147L38.6383 38.0573L36.753 39.9427ZM30.029 34.6667C30.6882 34.6667 31.3327 34.4712 31.8809 34.1049C32.429 33.7386 32.8563 33.218 33.1086 32.6089C33.3609 31.9999 33.4269 31.3296 33.2983 30.683C33.1696 30.0364 32.8522 29.4425 32.386 28.9763C31.9198 28.5101 31.3259 28.1927 30.6793 28.064C30.0327 27.9354 29.3625 28.0014 28.7534 28.2537C28.1443 28.506 27.6237 28.9333 27.2574 29.4814C26.8911 30.0296 26.6956 30.6741 26.6956 31.3333C26.6956 32.2174 27.0468 33.0652 27.672 33.6903C28.2971 34.3155 29.1449 34.6667 30.029 34.6667Z",
    fill: "#FEF335"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_2908_11628",
    x: 9.3623,
    y: 8,
    width: 29.2759,
    height: 36,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.529167 0 0 0 0 0.508 0 0 0 0 0 0 0 0 0.35 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_2908_11628"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUxaudit);
export default __webpack_public_path__ + "static/media/uxaudit.98aca2fa4ca1b91f28c2dcb71f0ec0de.svg";
export { ForwardRef as ReactComponent };